// TODO merge this with customersService, unify types

import { queryOptions, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiUrls } from "../helpers/apiUrls";
import { useAxiosPrivate } from "../hooks/useAxiosPrivate";

export function useGetPersonsRepository(params, options = {}) {
    const axiosPriv = useAxiosPrivate();

    const queryOpts = queryOptions({
        ...options,
        queryKey: ["personRepository", params],
        queryFn: () => {
            return personRepositoryService.getPersonsRepository(axiosPriv, params);
        },
    });

    return useQuery({
        ...queryOpts,
    });
}

export function useGetPersonDetails(personId, options = {}) {
    const axiosPriv = useAxiosPrivate();

    const queryOpts = queryOptions({
        ...options,
        queryKey: ["personDetails", personId],
        queryFn: () => {
            return personRepositoryService.getPersonDetails(axiosPriv, personId);
        },
    });

    return useQuery({
        ...queryOpts,
    });
}

export function useEditPersonMutation(options = {}) {
    const axiosPriv = useAxiosPrivate();
    const queryClient = useQueryClient();

    return useMutation({
        ...options,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["personRepository"] });
            queryClient.invalidateQueries({
                queryKey: ["personDetails", variables.personId],
            });
            options.onSuccess?.(data, variables, context);
        },
        mutationFn: (data) => {
            return personRepositoryService.editPerson(axiosPriv, {
                personId: data.personId,
                name: data.name,
                surname: data.surname,
                phone: data.phone,
                email: data.email,
            });
        },
    });
}

export const personRepositoryService = {
    getPersonsRepository: async (axios, params) => {
        const response = await axios.get(apiUrls.customers.personIndex, { params });
        return response.data;
    },

    getPersonDetails: async (axios, personId) => {
        const response = await axios.get(apiUrls.customers.persons.detail(personId));
        return response.data;
    },

    editPerson(axiosPriv, data) {
        // TODO
        return axiosPriv.put(apiUrls.sales.persons.person(data.personId), {
            email: data.email
                ? {
                      email_address: data.email,
                  }
                : null,
            phone: data.phone
                ? {
                      phone_number: data.phone,
                      // phone_note: ""
                  }
                : null,
            // "clause_decisions": [],
            // "active": false,
            // "person_ocid": null,
            person_name: data.name,
            // "person_name2": "",
            person_surname: data.surname,
            // "person_pesel": "",
            // "person_idcard": "",
            // "person_passport": "",
            // "creator": null
            // },
            // "reason": null,
            // "address_living": {
            //     "city": "",
            //     "zip_code": "",
            //     "street": "",
            //     "building": "",
            //     "flat_nr": ""
            // },
            // "address_correspondence": {
            //     "city": "",
            //     "zip_code": "",
            //     "street": "",
            //     "building": "",
            //     "flat_nr": ""
            // },
            // "related_persons": []
        });
    },
};
